@if (!(isPhonePortrait$ | async)) {
  <div class="computer">
    <div class="main">
      <div (click)="prev()" class="prev"></div>
      <div (click)="next()" class="next"></div>
      <img [src]="currentImage$ | async | publicImageUrl: 1600:1600 | async" />
    </div>
    <div class="thumbs">
      @for (image of images; track image) {
        <div class="small">
          <img
            (click)="imageClicked(image)"
            [src]="image.fileName | publicImageUrl: 1600:1600 | async"
            />
          </div>
        }
      </div>
    </div>
  }
  @if (isPhonePortrait$ | async) {
    <div class="phone">
      <div class="main">
        <img [src]="currentImage$ | async | publicImageUrl: 1600:1600 | async" />
      </div>
      <div class="thumbs">
        @for (image of images; track image) {
          <div class="small">
            <img
              (click)="imageClicked(image)"
              [src]="image.fileName | publicImageUrl: 1600:1600 | async"
              />
            </div>
          }
        </div>
      </div>
    }
